module.exports = __webpack_public_path__ + "static/media/logo.aa919617.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 361
// module chunks = 0